<template>
  <v-form v-model="valid" ref="form" :disabled="loading" @submit.prevent>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-img
            :src="require('@/assets/banner-finantare_alt.png')"
            class="mx-auto"
            contain
            max-height="150px"
          ></v-img>
        </v-col>
      </v-row>

      <v-card class="pa-md-4 mx-auto" max-width="900px">
        <v-card-text>
          <h1 class="text-h4 text-center mb-3">Detalii Personale</h1>

          <v-alert type="info" class="mt-2" v-if="!completedPersonal">
            Va rugam sa completati datele dumneavoastra. Doar dupa ce ati completat toate informatiile puteti trece mai deparete la depunerea dosarului.
          </v-alert>

          <v-text-field
            prepend-icon="mdi-account-circle"
            shaped
            rounded
            solo
            dense
            flat
            outlined
            single-line
            v-model="nume"
            label="Nume"
            required
            hint="Numele dumneavoastra"
            persistent-hint
          ></v-text-field>

          <v-text-field
            shaped
            prepend-icon="mdi-account-supervisor"
            rounded
            solo
            dense
            flat
            outlined
            single-line
            v-model="prenume"
            label="Prenume"
            requiered
            hint="Prenumele dumneavoastra"
            persistent-hint
          ></v-text-field>

          <v-text-field
            shaped
            prepend-icon="mdi-identifier"
            rounded
            solo
            dense
            flat
            outlined
            :counter="13"
            single-line
            v-model="cnp"
            :rules="cnpRules"
            label="CNP"
            required
            hint="CNP-ul dumneavoastra"
            persistent-hint
          ></v-text-field>

          <v-select
            :items="items"
            v-model="judet"
            label="Judet"
            rounded
            solo
            dense
            flat
            outlined
            single-line
            shaped
            prepend-icon="mdi-city"
            hint="Selectati judetul corespunzator domiciliului sau resedintei din CI, dupa caz (in functie de adresa cu care v-ati inscris in grupul tinta al proiectului)"
            persistent-hint
          ></v-select>

          <v-file-input
            type="file"
            rounded
            solo
            dense
            shaped
            flat
            outlined
            single-line
            v-model="ciFile"
            multiple
            label="Copie CI fata si verso"
            hint="Incarca pdf continand copia CI fata si verso, dupa caz (documentul scanat sa contina atat domiciliul cat si resedinta)"
            persistent-hint
            accept="application/pdf, image/*">
            <template v-slot:selection="{ index }">
              <span v-if="index === 0">{{ ciFile.length }} fisiere</span>
            </template>
          </v-file-input>

          <template v-for="(url, index) in ciImage">
            <a :href="url" target="_blank" class="ml-10 text-decoration-none" :key="url" v-if="url">
              fisier {{ index + 1 }}
              <v-icon small color="primary">mdi-download</v-icon>
            </a>
          </template>

          <v-switch
            v-model="hasCert"
            :label="`Ati parcurs cursul de antreprenoriat?`">
          </v-switch>

          <template v-if="hasCert == true">
            <v-file-input
              shaped
              label="Incarca Certificat/Adeverinta Curs"
              rounded
              solo
              dense
              flat
              outlined
              v-model="certFile"
              multiple
              single-line
              hint="Dovada absolvirii cursului de antreprenoriat"
              persistent-hint
              accept="application/pdf, image/*">
              <template v-slot:selection="{ index }">
                <span v-if="index === 0">{{ certFile.length }} fisiere</span>
              </template>
            </v-file-input>

            <template v-for="(url, index) in certImage">
              <a :href="url" target="_blank" class="ml-10 text-decoration-none" v-if="url" :key="url">
                fisier {{ index + 1 }}
                <v-icon small color="primary">mdi-download</v-icon>
              </a>
            </template>
          </template>

          <v-alert v-if="completedPersonal" type="info" class="mt-2">
            Mergi la Completeaza formular in partea dreapta a ecranului (<router-link :to="{ path: '/Form' }" class="white--text">link</router-link>)!
            Daca ai nelamuri privind pasii urmatori, vizioneaza tutorialul din prima pagina (<router-link :to="{ path: '/Home' }" class="white--text">link</router-link>).
            Inca nelamurit? Citeste Metodologia de selectie planuri de afaceri si celelalte documente din sectiunea Resurse (<router-link :to="{ path: '/About' }" class="white--text">link</router-link>).
            Tot nelamurit? Mergi la Contact (<router-link :to="{ path: '/Contact' }" class="white--text">link</router-link>) si trimite-ne un e-mail; vei primi un raspuns in cel mai scurt timp!
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            large
            color="primary"
            @click="saveDetails"
            :diabled="loading"
            :loading="loading"
          >
            Salvati informatiile
            <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light color="white">mdi-cached</v-icon>
              </span>
            </template>
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "personal-details",
  data: () => ({
    hasCert: false,
    valid: false,
    items: [
      "Municipiul Bucuresti",
      "Judetul Alba",
      "Judetul Arad",
      "Judetul Arges",
      "Judetul Bacau",
      "Judetul Bihor",
      "Judetul Bistrita-Nasaud",
      "Judetul Botosani",
      "Judetul Braila",
      "Judetul Brasov",
      "Judetul Buzau",
      "Judetul Calarasi",
      "Judetul Caras-Severin",
      "Judetul Cluj",
      "Judetul Constanta",
      "Judetul Covasna",
      "Judetul Dambovita",
      "Judetul Dolj",
      "Judetul Galati",
      "Judetul Giurgiu",
      "Judetul Gorj",
      "Judetul Harghita",
      "Judetul Hunedoara",
      "Judetul Ialomita",
      "Judetul Iasi",
      "Judetul Ilfov",
      "Judetul Maramures",
      "Judetul Mehedinti",
      "Judetul Mures",
      "Judetul Neamt",
      "Judetul Olt",
      "Judetul Prahova",
      "Judetul Salaj",
      "Judetul Satu Mare",
      "Judetul Sibiu",
      "Judetul Suceava",
      "Judetul Teleorman",
      "Judetul Timis",
      "Judetul Tulcea",
      "Judetul Valcea",
      "Judetul Vaslui",
      "Judetul Vrancea"
    ],
    nume: null,
    prenume: null,
    ciImage: null,
    certImage: null,
    ciFile: [],
    certFile: [],
    cnp: null,
    judet: null,
    cnpRules: [
      v => !!v || "CNP-ul este obligatoriu",
      v => (v && v.length === 13 && !isNaN(v)) || "Aveti nevoie de 13 cifre pentru a inregistra CNP"
    ],
    nameRules: [
      v => !!v || "Campul este obligatoriu",
      v => (v && v.length >= 2) || "Introduceti cel putin 2 caractere"
    ]
  }),
  watch: {
    personal: {
      immediate: true,
      deep: true,
      handler(value) {
        this.nume = value.nume;
        this.prenume = value.prenume;
        this.judet = value.judet;
        this.cnp = value.cnp;
        this.ciImage = Array.isArray(value.ciUrl) ? value.ciUrl : [ value.ciUrl ];
        this.certImage = Array.isArray(value.certUrl) ? value.certUrl : [ value.certUrl ];
        this.hasCert = !!value.hasCert;
      }
    }
  },
  computed: {
    personal() {
      return this.$store.getters.personal;
    },
    completedPersonal() {
      return !!this.personal.nume &&
             !!this.personal.prenume &&
             !!this.personal.judet &&
             !!this.personal.cnp &&
             !!this.personal.hasCert &&
             !!this.personal.certUrl &&
             Array.isArray(this.personal.ciUrl) &&
             !!this.personal.ciUrl.length;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    saveDetails() {
      const formData = {
        nume: this.nume,
        prenume: this.prenume,
        cnp: this.cnp,
        judet: this.judet,
        ciFile: this.ciFile,
        certFile: this.certFile,
        hasCert: this.hasCert,
        ciImage: this.ciImage,
        certImage: this.certImage
      };
      this.$store.dispatch("createPersonal", formData);
      this.$refs.form.reset();
      this.ciImage = null;
      this.certImage = null;
      this.ciFile = [];
      this.certFile = [];
    }
  }
};
</script>
